<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<div *ngIf="items.length > 0">
		<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
			</thead>

			<tbody *ngIf="!loading && itemsToShow?.length > 0">
				<tr *ngFor="let item of itemsToShow" [ngClass]="{
					'text-danger': item.is_enabled === 0,
					'text-warning': item.is_enabled === 1 && item['__issues'] && item['__issues'] !== '' }">
					<td [hidden]="!fieldsToShow.includes('is_favorite')" *ngIf="showFavorite" class="cp-icon-cell">
						<fa-icon *ngIf="item.is_favorite === 1" [icon]="starIcon" size="sm" class="text-success" ngbTooltip="Favorite"
							placement="end"></fa-icon>
					</td>
					<td [hidden]="!fieldsToShow.includes('is_enabled')" class="cp-icon-cell">
						<fa-icon *ngIf="item.is_enabled === 1" [icon]="['fas', 'power-off']" size="sm" class="text-success"
							ngbTooltip="Enabled - Downloads available" placement="end"></fa-icon>
						<fa-icon *ngIf="item.is_enabled === 0" [icon]="['fas', 'ban']" size="sm" class="text-danger"
							ngbTooltip="Disabled - Downloads not available" placement="end"></fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('__issues')" class="cp-icon-cell">
						<fa-icon *ngIf="item['__issues'] && item['__issues'] !== ''" [icon]="['fas', 'exclamation-triangle']" size="sm"
							placement="end" class="text-danger" [ngbTooltip]="item['__issues']">
						</fa-icon>
						<fa-icon *ngIf="!item['__issues'] || item['__issues'] === ''" [icon]="['fas', 'check']" size="sm" placement="end"
							class="text-success" ngbTooltip="No Issues">
						</fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('name')" class="cp-chopped-col-long">
						<a [routerLink]="['/' + ac.urls.organizations, item.id]" [ngbPopover]="organizationPopupContent"
							popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
							{{ item.name }}
						</a>
					</td>
					<td [hidden]="!fieldsToShow.includes('otype')" class="cp-chopped-col-medium">
						{{ ac.organizationTypeLabels[item.otype] }}
					</td>
					<td [hidden]="!fieldsToShow.includes('__roles')" class="cp-chopped-col-medium">
						<span *ngIf="item['__roles']" [ngbTooltip]="item['__roles']">
							{{ item['__roles'] }}
						</span>
					</td>
					<td [hidden]="!fieldsToShow.includes('salesforce_account_owner')" *ngIf="showSalesRep" class="cp-icon-cell text-center">
						<span *ngIf="item.salesforce_account_owner" [ngbTooltip]="item.salesforce_account_owner">
							{{ item.salesforce_account_owner | acronym }}
						</span>
					</td>
					<td [hidden]="!fieldsToShow.includes('salesforce_se')" *ngIf="showSalesEng" class="cp-icon-cell text-center">
						<span *ngIf="item.salesforce_se" [ngbTooltip]="item.salesforce_se">
							{{ item.salesforce_se | acronym }}
						</span>
					</td>
					<td [hidden]="!fieldsToShow.includes('salesforce_tam')" *ngIf="showSalesEng" class="cp-icon-cell text-center">
						<span *ngIf="item.salesforce_tam" [ngbTooltip]="item.salesforce_tam">
							{{ item.salesforce_tam | acronym }}
						</span>
					</td>
					<td [hidden]="!fieldsToShow.includes('salesforce_sa')" *ngIf="showSalesEng" class="cp-icon-cell text-center">
						<span *ngIf="item.salesforce_sa" [ngbTooltip]="item.salesforce_sa">
							{{ item.salesforce_sa | acronym }}
						</span>
					</td>
					<td [hidden]="!fieldsToShow.includes('num_users')" class="text-center">
						{{ item.num_users | number }}
					</td>
					<td [hidden]="!fieldsToShow.includes('__num_groups')" class="text-center">
						{{ item.group_ids.length | number }}
					</td>
					<td [hidden]="!fieldsToShow.includes('__num_products_platforms')" class="text-center">
						{{ item.product_platforms.length | number }}
					</td>
					<td [hidden]="!fieldsToShow.includes('__num_builds')" class="text-center">
						{{ item.build_ids.length | number }}
					</td>
					<td [hidden]="!fieldsToShow.includes('__num_documents')" class="text-center">
						{{ item.document_ids.length | number }}
					</td>
					<td [hidden]="!fieldsToShow.includes('num_partnerships')" class="text-center">
						{{ item.num_partnerships | number }}
					</td>
					<td [hidden]="!fieldsToShow.includes('num_active_zen_domains')" class="text-center">
						{{ item.num_active_zen_domains |
						number }}
					</td>
					<td [hidden]="!fieldsToShow.includes('num_keys')" class="text-center">
						{{ item.num_keys | number }}
					</td>
					<td [hidden]="!fieldsToShow.includes('num_billing_codes')" class="text-center">
						{{ item.num_billing_codes | number }}
					</td>

					<td [hidden]="!fieldsToShow.includes('added_on')" class="text-center text-nowrap">
						<div *ngIf="item.added_on" [ngbTooltip]="item.added_on | date: ac.shortPageDateTimeFmt">
							{{ item.added_on | timeback }}
						</div>
					</td>
					<td [hidden]="!fieldsToShow.includes('last_download')" class="text-center text-nowrap">
						<div *ngIf="item.last_download" [ngbTooltip]="item.last_download | date: ac.shortPageDateTimeFmt">
							{{ item.last_download | timeback }}
						</div>
					</td>

					<ng-template #organizationPopupContent>
						<app-card-organization [object]="item"></app-card-organization>
					</ng-template>
				</tr>
			</tbody>
		</table>
		<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
			[centered]="false"></app-paging-bar>
	</div>

</div>